module.exports = __webpack_public_path__ + "img/cover-minigame-bg-mobile.1f48ea5b.jpg";